module.exports = __webpack_public_path__ + "img/ftls.44009c90.png";